import React from 'react';
import SmartWizard from './components/SmartWizard';

function App() {
  return (
    <div className="App">
      <SmartWizard />
    </div>
  );
}

export default App;